import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Desafios_Cursos } from 'generated/graphql';

interface CursoProfesorDesafioI {
	cursoKey: string;
	desafioCursoKey: string;
	desafioCurso?: Desafios_Cursos;
}

const initialState: CursoProfesorDesafioI = {
	cursoKey: '',
	desafioCursoKey: ''
};

const cursoProfesorDesafioStateSlice = createSlice({
	name: 'cursoProfesorDesafioState',
	initialState,
	reducers: {
		setCursoProfesorDesafio: (state, action: PayloadAction<CursoProfesorDesafioI>) => {
			return action.payload;
		},
		resetCursoProfesorDesafio: () => {
			return initialState;
		}
	}
});

export const { setCursoProfesorDesafio, resetCursoProfesorDesafio } = cursoProfesorDesafioStateSlice.actions;
export default cursoProfesorDesafioStateSlice.reducer;
